import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import Input from "../../../../../../../components/textbox/Input";
import Utils from "../../../../../../../utils/Utils";

class FattoriDiRischioTubercolosi extends Component {

    state = {
        fattoriDiRischio: {
            rischioMedico: "",
            esitiRadioGrafici: "",
            graveImmunodeficienza: "",
            terapiaImmunosoppressiva: "",
            deperimentoOrganicoGrave: "",
            recenteViaggioTubercolinico: "",
            diabeteScarsamenteControllato: "",
            silicosi: "",
            insufficienzaRenaleCronica: "",
            gastrectomia: "",
            altroRischioMedico: "",
            inputAltroRischioMedico: "",

            altriFattori: "",
            contattoConMalato: "",
            tossicoDipendenza: "",
            immigrazione: "",
            carcere: "",
            alcolismo: "",
            senzaFissaDimora: "",
            personaleSanitario: "",
            fumo: "",
            altroAltriFattori: "",
            inputAltroAltriFattori: "",

            corretto: []

        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
    }

    componentDidMount() {
        let fattoriDiRischio = this.state.fattoriDiRischio
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio) {
            let fattoriDiRischioProps = this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio
            fattoriDiRischio.rischioMedico = fattoriDiRischioProps.rischioMedico === "true"? fattoriDiRischioProps.rischioMedico : this.state.fattoriDiRischio.rischioMedico
            fattoriDiRischio.esitiRadioGrafici = fattoriDiRischioProps.esitiRadioGrafici === "true" ? fattoriDiRischioProps.esitiRadioGrafici : this.state.fattoriDiRischio.esitiRadioGrafici
            fattoriDiRischio.graveImmunodeficienza = fattoriDiRischioProps.graveImmunodeficienza === "true" ? fattoriDiRischioProps.graveImmunodeficienza : this.state.fattoriDiRischio.graveImmunodeficienza
            fattoriDiRischio.terapiaImmunosoppressiva = fattoriDiRischioProps.terapiaImmunosoppressiva === "true" ? fattoriDiRischioProps.terapiaImmunosoppressiva : this.state.fattoriDiRischio.terapiaImmunosoppressiva
            fattoriDiRischio.deperimentoOrganicoGrave = fattoriDiRischioProps.deperimentoOrganicoGrave === "true" ? fattoriDiRischioProps.deperimentoOrganicoGrave : this.state.fattoriDiRischio.deperimentoOrganicoGrave
            fattoriDiRischio.recenteViaggioTubercolinico = fattoriDiRischioProps.recenteViaggioTubercolinico === "true" ? fattoriDiRischioProps.recenteViaggioTubercolinico : this.state.fattoriDiRischio.recenteViaggioTubercolinico
            fattoriDiRischio.diabeteScarsamenteControllato = fattoriDiRischioProps.diabeteScarsamenteControllato === "true" ? fattoriDiRischioProps.diabeteScarsamenteControllato : this.state.fattoriDiRischio.diabeteScarsamenteControllato
            fattoriDiRischio.silicosi = fattoriDiRischioProps.silicosi === "true" ? fattoriDiRischioProps.silicosi : this.state.fattoriDiRischio.silicosi
            fattoriDiRischio.insufficienzaRenaleCronica = fattoriDiRischioProps.insufficienzaRenaleCronica === "true"? fattoriDiRischioProps.insufficienzaRenaleCronica : this.state.fattoriDiRischio.insufficienzaRenaleCronica
            fattoriDiRischio.gastrectomia = fattoriDiRischioProps.gastrectomia === "true"? fattoriDiRischioProps.gastrectomia : this.state.fattoriDiRischio.gastrectomia
            fattoriDiRischio.altroRischioMedico = fattoriDiRischioProps.altroRischioMedico === "true"? fattoriDiRischioProps.altroRischioMedico : this.state.fattoriDiRischio.altroRischioMedico
            fattoriDiRischio.inputAltroRischioMedico = fattoriDiRischioProps.inputAltroRischioMedico? fattoriDiRischioProps.inputAltroRischioMedico : this.state.fattoriDiRischio.inputAltroRischioMedico
            fattoriDiRischio.altriFattori = fattoriDiRischioProps.altriFattori === "true"? fattoriDiRischioProps.altriFattori : this.state.fattoriDiRischio.altriFattori
            fattoriDiRischio.contattoConMalato = fattoriDiRischioProps.contattoConMalato === "true"? fattoriDiRischioProps.contattoConMalato : this.state.fattoriDiRischio.contattoConMalato
            fattoriDiRischio.tossicoDipendenza = fattoriDiRischioProps.tossicoDipendenza === "true"? fattoriDiRischioProps.tossicoDipendenza : this.state.fattoriDiRischio.tossicoDipendenza
            fattoriDiRischio.immigrazione = fattoriDiRischioProps.immigrazione === "true"? fattoriDiRischioProps.immigrazione : this.state.fattoriDiRischio.immigrazione
            fattoriDiRischio.carcere = fattoriDiRischioProps.carcere === "true"? fattoriDiRischioProps.carcere : this.state.fattoriDiRischio.carcere
            fattoriDiRischio.alcolismo = fattoriDiRischioProps.alcolismo === "true"? fattoriDiRischioProps.alcolismo : this.state.fattoriDiRischio.alcolismo
            fattoriDiRischio.senzaFissaDimora = fattoriDiRischioProps.senzaFissaDimora === "true"? fattoriDiRischioProps.senzaFissaDimora : this.state.fattoriDiRischio.senzaFissaDimora
            fattoriDiRischio.fumo = fattoriDiRischioProps.fumo === "true"? fattoriDiRischioProps.fumo : this.state.fattoriDiRischio.fumo
            fattoriDiRischio.personaleSanitario = fattoriDiRischioProps.personaleSanitario === "true"? fattoriDiRischioProps.personaleSanitario : this.state.fattoriDiRischio.personaleSanitario
            fattoriDiRischio.altroAltriFattori = fattoriDiRischioProps.altroAltriFattori === "true"? fattoriDiRischioProps.altroAltriFattori : this.state.fattoriDiRischio.altroAltriFattori
            fattoriDiRischio.inputAltroAltriFattori = fattoriDiRischioProps.inputAltroAltriFattori? fattoriDiRischioProps.inputAltroAltriFattori : this.state.fattoriDiRischio.inputAltroAltriFattori
        }
        this.setState({fattoriDiRischio: fattoriDiRischio});
        let oggetto = this.createOggettoBE()
        this.props.setFattoriDiRischioTubercolosi(this.state.fattoriDiRischio, oggetto)
    }

    riceviValore(field, event) {
        let fattoriDiRischio = this.state.fattoriDiRischio
        fattoriDiRischio[field] = event.target.value
        if (fattoriDiRischio.altroAltriFattori !== "true") {
            fattoriDiRischio.inputAltroAltriFattori = ""
        }
        if (fattoriDiRischio.altroRischioMedico !== "true") {
            fattoriDiRischio.inputAltroRischioMedico = ""
        }
        this.setState({fattoriDiRischio: fattoriDiRischio})
        let oggetto = this.createOggettoBE()
        this.controlloCorrettezza()
        this.props.setFattoriDiRischioTubercolosi(this.state.fattoriDiRischio, oggetto)
    }

    controlloCorrettezza() {
        let fattoriDiRischio = this.state.fattoriDiRischio
        fattoriDiRischio.corretto = []

        if(fattoriDiRischio.altroRischioMedico === "true" && !fattoriDiRischio.inputAltroRischioMedico) fattoriDiRischio.corretto[0] = "Campo \"Rischio Medico - Altro\" mancante";
        if(fattoriDiRischio.altroAltriFattori === "true" && !fattoriDiRischio.inputAltroAltriFattori) fattoriDiRischio.corretto[1] = "Campo \"Altri Fattori - Altro\" mancante";

    }

    createOggettoBE() {
        let fattoriDiRischio = JSON.parse(JSON.stringify(this.state.fattoriDiRischio))
        let fattoriDiRischioBe = Utils.removeEmptyValueFromObject(fattoriDiRischio)
        return Utils.removeFieldFromObject(fattoriDiRischioBe, "corretto")
    }

    render() {
        const {t} = this.props
        const fattoriDiRischio = (
            <div className={"container"}>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-3"}>
                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold", fontSize: "18px"}}>
                            {t("SchedaSpecialeTubercolosi.fattoriDiRischio")}
                        </p>
                    </div>
                    <div className={"col-lg-5"}>
                        <CheckBox id={"rischioMedico"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.rischioMedico["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.rischioMedico === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.rischioMedico")}
                                  contenutoCheckBox={"A"}
                                  fontWeight={"bold"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"esitiRadioGrafici"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.esitiRadioGrafici["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.esitiRadioGrafici === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.esitiRadioGrafici")}
                                  contenutoCheckBox={"1"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"graveImmunodeficienza"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.graveImmunodeficienza["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.graveImmunodeficienza === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.graveImmunodeficenza")}
                                  contenutoCheckBox={"2"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"terapiaImmunosoppressiva"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.terapiaImmunosoppressiva["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.terapiaImmunosoppressiva === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.terapiaImmunosoppressiva")}
                                  contenutoCheckBox={"3"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"deperimentoOrganicoGrave"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.deperimentoOrganicoGrave["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.deperimentoOrganicoGrave === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.deperimentoOrganicoGrave")}
                                  contenutoCheckBox={"4"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"recenteViaggioTubercolinico"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.recenteViaggioTubercolinico["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.recenteViaggioTubercolinico === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.recenteViaggioTubercolinico")}
                                  contenutoCheckBox={"5"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"diabeteScarsamenteControllato"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.diabeteScarsamenteControllato["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.diabeteScarsamenteControllato === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.diabeteScarsamenteControllato")}
                                  contenutoCheckBox={"6"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"silicosi"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.silicosi["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.silicosi === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.silicosi")}
                                  contenutoCheckBox={"7"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"insufficienzaRenaleCronica"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.insufficienzaRenaleCronica["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.insufficienzaRenaleCronica === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.insufficienzaRenaleCronica")}
                                  contenutoCheckBox={"8"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"gastrectomia"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.gastrectomia["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.gastrectomia === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.gastrectomia")}
                                  contenutoCheckBox={"9"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <div className={"row"}>
                            <div className={"col-lg-3"}>
                                <CheckBox id={"altroRischioMedico"}
                                          isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                          checked={this.state.fattoriDiRischio.altroRischioMedico["checked"]}
                                          defaultChecked={
                                              this.props.segnalazioneCopia.schedaSpeciale &&
                                              this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                              this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.altroRischioMedico === "true"? true : false}
                                          text={t("SchedaSpecialeTubercolosi.altro")}
                                          contenutoCheckBox={"10"}
                                          styleContenuto={{
                                              display: "inline-block",
                                              paddingLeft: "8px", paddingTop: "0.5px", fontSize: "13px", color: "black"
                                          }}
                                          onChange={this.riceviValore}
                                          newCheckbox={true}
                                >
                                </CheckBox>
                            </div>
                            <div className={"col-lg-5"}>
                                <Input id={"inputAltroRischioMedico"}
                                       onChange={this.riceviValore}
                                       field={"inputAltroRischioMedico"}
                                       required={this.state.fattoriDiRischio.altroRischioMedico === "true"}
                                       value={this.state.fattoriDiRischio.inputAltroRischioMedico}
                                       placeholder={t("SchedaSpecialeTubercolosi.altro")}
                                       disabled={this.state.fattoriDiRischio.altroRischioMedico !== "true"}>
                                </Input>
                            </div>
                        </div>

                    </div>
                    <div className={"col-lg-4"}>
                        <CheckBox id={"altriFattori"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  ì checked={this.state.fattoriDiRischio.altriFattori["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.altriFattori === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.altriFattori")}
                                  contenutoCheckBox={"B"}
                                  fontWeight={"bold"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"contattoConMalato"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  ì checked={this.state.fattoriDiRischio.contattoConMalato["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.contattoConMalato === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.contattoConMalato")}
                                  contenutoCheckBox={"1"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"tossicoDipendenza"}
                                  checked={this.state.fattoriDiRischio.tossicoDipendenza["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.tossicoDipendenza === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.tossicoDipendenza")}
                                  contenutoCheckBox={"2"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"immigrazione"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.immigrazione["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.immigrazione === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.immigrazione")}
                                  contenutoCheckBox={"3"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"carcere"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.carcere["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.carcere === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.carcere")}
                                  contenutoCheckBox={"4"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"alcolismo"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.alcolismo["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.alcolismo === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.alcolismo")}
                                  contenutoCheckBox={"5"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"senzaFissaDimora"}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  checked={this.state.fattoriDiRischio.senzaFissaDimora["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.senzaFissaDimora === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.senzaFissaDimora")}
                                  contenutoCheckBox={"6"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"personaleSanitario"}
                                  checked={this.state.fattoriDiRischio.personaleSanitario["checked"]}
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.personaleSanitario === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.personaleSanitario")}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  contenutoCheckBox={"7"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <CheckBox id={"fumo"}
                                  checked={this.state.fattoriDiRischio.fumo["checked"]}
                                  isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                  defaultChecked={
                                      this.props.segnalazioneCopia.schedaSpeciale &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                      this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.fumo === "true"? true : false}
                                  text={t("SchedaSpecialeTubercolosi.fumo")}
                                  contenutoCheckBox={"8"}
                                  onChange={this.riceviValore}
                                  newCheckbox={true}
                        >
                        </CheckBox>
                        <div className={"row"}>
                            <div className={"col-lg-3"}>
                                <CheckBox id={"altroAltriFattori"}
                                          isRadio={false} //prop aggiuntiva che indica se il comportamento è quello di un radiobutton
                                          checked={this.state.fattoriDiRischio.altroAltriFattori["checked"]}
                                          defaultChecked={
                                              this.props.segnalazioneCopia.schedaSpeciale &&
                                              this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio &&
                                              this.props.segnalazioneCopia.schedaSpeciale.fattoriDiRischio.altroAltriFattori === "true"? true : false}
                                          text={t("SchedaSpecialeTubercolosi.altro")}
                                          contenutoCheckBox={"9"}
                                          onChange={this.riceviValore}
                                          newCheckbox={true}
                                >
                                </CheckBox>
                            </div>
                            <div className={"col-lg-5"}>
                                <Input id={"inputAltroAltriFattori"}
                                       onChange={this.riceviValore}
                                       field={"inputAltroAltriFattori"}
                                       required={this.state.fattoriDiRischio.altroAltriFattori === "true"}
                                       value={this.state.fattoriDiRischio.inputAltroAltriFattori}
                                       placeholder={t("SchedaSpecialeTubercolosi.altro")}
                                       disabled={this.state.fattoriDiRischio.altroAltriFattori !== "true"}
                                >
                                </Input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        return (
            <div>
                {fattoriDiRischio}
            </div>
        )
    }
}

export default withTranslation('common')(FattoriDiRischioTubercolosi)
